var _title, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalAttribute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#fff",
    opacity: "undefined",
    d: "m101.7917,68c-53.15378,0 -96.20835,-14.76796 -96.20835,-33c0,-18.23204 43.05457,-33 96.20835,-33c53.15378,0 96.20835,14.76796 96.20835,33c0,18.23204 -43.05457,33 -96.20835,33z",
    id: "svg_11"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      cursor: "move"
    },
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    id: "svg_4",
    y: 43,
    x: 60,
    strokeWidth: 0,
    stroke: "#000",
    fill: "#000000"
  }, "Attribute")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalAttribute);
export default __webpack_public_path__ + "static/media/NormalAttribute.ed06d7320ce6dbaf79fe2b568f22cb29.svg";
export { ForwardRef as ReactComponent };